export enum ELoginStep {
  EnterPhone,
  CreatePass,
  RepeatPass,
  CheckOTP,
  EnterEmail,
  CheckEmail,
  TelegramRedirect,
  ActivationMethod,
  Confirmation,
}

export enum ELoginStepYandex {
  AuthYandex,
  ChooseNumber,
  CreatePass,
  RepeatPass,
}
